// extracted by mini-css-extract-plugin
export default {"disclosureButton":"DisclosureDropdown_disclosureButton__ddqsr"};